var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    enableBackground: "new 0 0 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-right",
    fill: "#8A1538",
    d: "M13.127,4.452l1.238-1.238c0.519-0.523,1.363-0.525,1.885-0.005 c0.002,0.001,0.005,0.004,0.006,0.005l10.851,10.839c0.521,0.521,0.525,1.363,0.006,1.886c-0.003,0-0.004,0.004-0.006,0.005 L16.256,26.787c-0.519,0.521-1.362,0.524-1.885,0.004c-0.003,0-0.005-0.003-0.006-0.004l-1.238-1.238 c-0.522-0.523-0.522-1.373,0.003-1.895c0.006-0.007,0.013-0.013,0.019-0.019l6.722-6.404H3.84C3.102,17.233,2.502,16.637,2.5,15.9 c0-0.003,0-0.007,0-0.008v-1.784c-0.001-0.738,0.596-1.337,1.333-1.338c0.002,0,0.003,0,0.007,0h16.03l-6.722-6.404 c-0.534-0.505-0.559-1.347-0.054-1.881C13.105,4.474,13.116,4.463,13.127,4.452z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.ba983ae4bf33dbb86337ef27342b50b4.svg";
export { ForwardRef as ReactComponent };